// ファイル選択
import React from 'react';
import Form from 'react-bootstrap/Form';
var FileSelect = function (_a) {
    var file_upload = _a.file_upload, handleChange = _a.handleChange;
    return (React.createElement(Form.Control, { as: "select", onChange: handleChange, value: file_upload.default_value, disabled: file_upload.is_loading || file_upload.is_uploaded }, file_upload.source.map(function (source) {
        return (React.createElement("option", { key: source.key, value: source.key }, source.value));
    })));
};
export default FileSelect;
